import React, { useMemo, memo } from 'react';
import { ProgressCard as ProgressCardType, CanvasProps } from '../types';
import { ProgressCard } from './ProgressCard';
import { CanvasSkeleton } from './CanvasSkeleton';
import { EmailGenerationProgressCard } from './EmailGenerationProgressCard';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ProgressCardContainer = styled(Box)(({ theme }) => ({
    padding: '20px 20px 20px 0',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
}));

export const Canvas = memo(({
    isLoading, 
    details,
    isGeneratingEmail = false,
    streamingData,
    currentSection,
    onOpenEmailGenerationPopup
}: CanvasProps) => {
    // Memoize sorted details to prevent re-sorting on every render
    const sortedDetails = useMemo(() => {
        return [...details].sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
    }, [details]);

    // Show skeleton when loading
    if (isLoading) {
        return <CanvasSkeleton />;
    }

    return (
        <ProgressCardContainer>
            {sortedDetails.map((card, index) => (
                <ProgressCard 
                    key={`${card.title || 'card'}-${index}`} 
                    card={card} 
                />
            ))}
            
            {/* Email Generation Progress Card */}
            <EmailGenerationProgressCard
                isGeneratingEmail={isGeneratingEmail}
                streamingData={streamingData}
                currentSection={currentSection}
                onOpenEmailGenerationPopup={onOpenEmailGenerationPopup}
            />
        </ProgressCardContainer>
    );
});

// Add display name for debugging
Canvas.displayName = 'Canvas';

